import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { TrueWalletTransactionLogResponse } from '../../types'

type TrueWalletLogData = TrueWalletTransactionLogResponse

export const columns: ColumnDef<TrueWalletLogData>[] = [
	{
		accessorKey: 'logInfo',
		header: 'ข้อมูลรายการ',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p className="font-mono text-xs">{row.original.id}</p>
				<p className="text-xs text-muted-foreground">
					เลขรายงาน: {row.original.reportId || '-'}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'channelInfo',
		header: 'ช่องทาง/ผู้ทำรายการ',
		cell: ({ row }) => {
			const type = row.original.type
			const typeLabel = type === 'DEPOSIT' ? 'ฝากเงิน' : 'ถอนเงิน'
			const method = row.original.method
			const methodMap: Record<string, string> = {
				TRUE_WALLET: 'True Wallet',
				BANK: 'ธนาคาร',
				PAYMENT_GATEWAY: 'ธนาคารออโต้',
				AUTOSSLIP: 'Auto Slip',
			}
			return (
				<div className="space-y-1 text-sm">
					<p>{row.original.paymentGateway?.bankProviderName || '-'}</p>
					<p className="text-xs text-muted-foreground">
						ประเภท: {typeLabel} | วิธีการ: {methodMap[method] || method}
					</p>
					<p>ชื่อ: {row.original.name || '-'}</p>
					<p className="text-xs text-muted-foreground">
						เบอร์โทร: {row.original.phoneNumber || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'amount',
		header: 'ยอดเงิน',
		cell: ({ row }) => `฿${row.original.amount.toLocaleString()}`,
	},
	{
		accessorKey: 'dateInfo',
		header: 'เวลา',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>ทำรายการ: {row.original.dateTime || '-'}</p>
				<p className="text-xs text-muted-foreground">
					บันทึก:{' '}
					{format(new Date(row.original.createdAt), 'PPP HH:mm น.', {
						locale: th,
					})}
				</p>
			</div>
		),
	},
]
